import { useCallback, useEffect, useState } from "react";

type Theme = "light" | "dark";
const LS_KEY = "catalog.theme";

function readInitial(): Theme {
  try {
    const stored = localStorage.getItem(LS_KEY) as Theme | null;
    if (stored === "light" || stored === "dark") return stored;
  } catch {
    /* ignore */
  }
  if (typeof window !== "undefined" && window.matchMedia("(prefers-color-scheme: dark)").matches) {
    return "dark";
  }
  return "light";
}

export function useTheme(): { theme: Theme; toggle: () => void; set: (t: Theme) => void } {
  const [theme, setTheme] = useState<Theme>(readInitial);

  useEffect(() => {
    const root = document.documentElement;
    // R2 do plano de redesign: dois mecanismos escrevem o MESMO estado —
    // .dark (o que ja existia, usado pelo boot inline) e data-theme (o que
    // o handoff do redesign pede). Nunca escrever so um: quem tem tema
    // escuro salvo abriria claro no primeiro frame se um dos dois sumir.
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    root.dataset.theme = theme;
    try {
      localStorage.setItem(LS_KEY, theme);
    } catch {
      /* ignore */
    }
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((p) => (p === "light" ? "dark" : "light"));
  }, []);

  return { theme, toggle, set: setTheme };
}
